import { render, staticRenderFns } from "./LabelingPointEditor.vue?vue&type=template&id=cd9a6c88&scoped=true"
import script from "./LabelingPointEditor.vue?vue&type=script&lang=js"
export * from "./LabelingPointEditor.vue?vue&type=script&lang=js"
import style0 from "./LabelingPointEditor.vue?vue&type=style&index=0&id=cd9a6c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9a6c88",
  null
  
)

export default component.exports